import { FOOTER_MJML } from "../common/footer";
import { TRANSACTIONAL_HEADER } from "../common/header";

export const productUpdate = `
<mjml>
  <mj-head>
    <mj-title>Important Product Updates</mj-title>
    <mj-preview>New features and improvements are now available</mj-preview>
    <mj-attributes>
      <mj-all font-family="Arial, sans-serif" />
      <mj-text font-size="16px" color="#333333" line-height="1.5" />
    </mj-attributes>
  </mj-head>
  <mj-body>
    ${TRANSACTIONAL_HEADER("Product Update", "New features and improvements")}
    
    <mj-section background-color="#ffffff" padding="30px 0">
      <mj-column>
        <mj-text font-size="22px" color="#333333" font-family="Arial, sans-serif">Hello {{first_name}},</mj-text>
        <mj-text font-size="16px" color="#555555" font-family="Arial, sans-serif">We're constantly working to improve your experience with {{product_name}}. We're excited to share some important updates that are now available for your product.</mj-text>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="0 0 20px">
      <mj-column>
        <mj-image src="https://via.placeholder.com/600x250?text=Product+Updates" alt="Product Updates" />
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#f8f9fa" padding="20px 0">
      <mj-column>
        <mj-text font-size="24px" color="#333333" font-weight="bold" align="center">What's New</mj-text>
        <mj-divider border-color="#007bff" border-width="2px" width="100px" />
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#f8f9fa" padding="0 0 20px">
      <mj-column width="100%">
        <mj-table>
          <tr style="border-bottom: 1px solid #ecedee;">
            <td style="padding: 20px 15px 20px 0; width: 25%; vertical-align: top;">
              <div style="background-color: #007bff; color: white; padding: 8px 12px; border-radius: 4px; display: inline-block; font-weight: bold;">Feature Update</div>
            </td>
            <td style="padding: 20px 0;">
              <div style="font-weight: bold; font-size: 18px; margin-bottom: 5px;">Enhanced Performance</div>
              <div style="color: #555555;">We've optimized the core functionality to provide faster response times and smoother operation under heavy loads.</div>
            </td>
          </tr>
          <tr style="border-bottom: 1px solid #ecedee;">
            <td style="padding: 20px 15px 20px 0; width: 25%; vertical-align: top;">
              <div style="background-color: #28a745; color: white; padding: 8px 12px; border-radius: 4px; display: inline-block; font-weight: bold;">New Feature</div>
            </td>
            <td style="padding: 20px 0;">
              <div style="font-weight: bold; font-size: 18px; margin-bottom: 5px;">Advanced Analytics Dashboard</div>
              <div style="color: #555555;">Access comprehensive insights with our new analytics tools, helping you make more informed decisions.</div>
            </td>
          </tr>
          <tr>
            <td style="padding: 20px 15px 20px 0; width: 25%; vertical-align: top;">
              <div style="background-color: #ffc107; color: #333; padding: 8px 12px; border-radius: 4px; display: inline-block; font-weight: bold;">Improvement</div>
            </td>
            <td style="padding: 20px 0;">
              <div style="font-weight: bold; font-size: 18px; margin-bottom: 5px;">Redesigned User Interface</div>
              <div style="color: #555555;">A cleaner, more intuitive interface makes navigation simpler and improves overall user experience.</div>
            </td>
          </tr>
        </mj-table>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="30px 0">
      <mj-column>
        <mj-text font-size="20px" color="#333333" font-weight="bold">How to Update</mj-text>
        <mj-text font-size="16px" color="#555555">
          Updating your product is simple:
        </mj-text>
        <mj-text font-size="16px" color="#555555" padding="0px">
          1. Log into your account dashboard<br/>
          2. Navigate to "Settings" > "Updates"<br/>
          3. Click "Check for Updates"<br/>
          4. Follow the on-screen instructions to complete the process
        </mj-text>
        <mj-text font-size="16px" color="#555555" padding-top="15px">
          The update process typically takes 5-10 minutes. For assistance, please contact our support team.
        </mj-text>
        <mj-button background-color="#007bff" color="#ffffff" href="#" border-radius="4px" font-weight="bold">Update Now</mj-button>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#f8f9fa" padding="20px">
      <mj-column>
        <mj-text font-size="20px" font-weight="bold" align="center">Need Help?</mj-text>
        <mj-text font-size="16px" align="center">Our support team is ready to assist you with the update process.</mj-text>
        <mj-button background-color="#6c757d" color="#ffffff" font-family="Arial, sans-serif" href="#" width="200px" border-radius="4px">Contact Support</mj-button>
      </mj-column>
    </mj-section>
    
    ${FOOTER_MJML}
  </mj-body>
</mjml>
`;

// Template metadata for the gallery
export default {
  id: "productUpdate",
  name: "Product Update",
  category: "product",
  description:
    "A professional email template announcing product updates, new features, and improvements with clear instructions for users.",
  features: [
    "Update summary",
    "Feature highlights",
    "Improvement details",
    "Step-by-step update instructions",
    "Support information",
  ],
  subject: "Important Product Updates",
  subTitle: "New features and improvements are now available",
  mjmlTemplate: productUpdate,
};
